import type { AnimationControls } from 'framer-motion';
import { motion } from 'framer-motion';

import { type AnimatedIconHandle, withAnimatedIcon } from './withAnimatedIcon';

type BotIconRenderProps = {
  controls: AnimationControls;
  size: number;
};

const BotIconRender = ({ controls, size }: BotIconRenderProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 8V4H8" />
    <rect width="16" height="12" x="4" y="8" rx="2" />
    <path d="M2 14h2" />
    <path d="M20 14h2" />

    <motion.line
      x1={15}
      x2={15}
      initial="normal"
      animate={controls}
      variants={{
        normal: { y1: 13, y2: 15 },
        animate: {
          y1: [13, 14, 13],
          y2: [15, 14, 15],
          transition: {
            duration: 0.5,
            ease: 'easeInOut',
            delay: 0.2,
          },
        },
      }}
    />

    <motion.line
      x1={9}
      x2={9}
      initial="normal"
      animate={controls}
      variants={{
        normal: { y1: 13, y2: 15 },
        animate: {
          y1: [13, 14, 13],
          y2: [15, 14, 15],
          transition: {
            duration: 0.5,
            ease: 'easeInOut',
            delay: 0.2,
          },
        },
      }}
    />
  </svg>
);

export type BotIconHandle = AnimatedIconHandle;

export const BotIcon = withAnimatedIcon(BotIconRender, 'BotIcon');
